import { gql } from '@apollo/client';


export const JOIN_SCHOOL = gql`
mutation ConnectUserToSchool($inviteCode: String!) {
  connectUserToSchool(inviteCode: $inviteCode)
}
`;


export const CREATE_SCHOOL = gql`
mutation CreateSchool($input: SchoolInput) {
  createSchool(input: $input)
}
`;


export const DELETE_SCHOOL = gql`
mutation DeleteSchool($schoolID: Int) {
  deleteSchool(schoolID: $schoolID)
}
`;


export const SAVE_BILLING_HEADINGS = gql`
mutation UpdateBillHeadings($schoolID: Int, $data: JSON) {
    updateBillHeadings(schoolID: $schoolID, data: $data)
  }
`;



export const UPDATE_CAMPUS = gql`
mutation UpdateCampus($schoolID: Int, $id: Int, $name: String, $address: String) {
  updateCampus(schoolID: $schoolID, id: $id, name: $name, address: $address)
}
`;


export const CREATE_CAMPUS = gql`
mutation CreateCampus($schoolID: Int, $name: String, $address: String) {
  createCampus(schoolID: $schoolID, name: $name, address: $address)
}
`;

export const DELETE_CAMPUS = gql`
mutation DeleteCampus($schoolID: Int, $id: Int) {
  deleteCampus(schoolID: $schoolID, id: $id)
}
`;

export const UPDATE_TERM = gql`
mutation UpdateTerms($schoolID: Int, $input: [TermsInput!]) {
  updateTerms(schoolID: $schoolID, input: $input)
}
`;

export const UPDATE_SCHOOL_SETTINGS = gql`
mutation UpdateSchoolSettings($schoolID: Int, $settings: JSON) {
  updateSchoolSettings(schoolID: $schoolID, settings: $settings)
}
`;

export const UPDATE_SCHOOL_JSON = gql`
mutation UpdateSchoolJson($schoolID: Int, $inputObject: JSON) {
  updateSchoolJson(schoolID: $schoolID, inputObject: $inputObject)
}
`;

export const UPDATE_SCHOOL = gql`
mutation UpdateSchool($schoolID: Int, $input: SchoolUpdate) {
  updateSchool(schoolID: $schoolID, input: $input)    
}
`;


export const GET_SCHOOL = gql`
query getSchool($schoolID: Int) {
  getSchool(schoolID: $schoolID) { 
    id
    name
    logo
    phone
    email
    website
    address
    news
    activeTerm
    json 
    plan
    expiry
    aiCredit
    smsCode
    birthdays {
      id
      celebrant
      birthday
      contacts
      role
    }
    campus {
      id
      name
      address
    }
    staff {
      id
      role
    }
    parents {
      id
      studentID
    }
    billHeadings
    classrooms {
      id
      name
      real_class
      campusID
      bill
      reportCardFormat
      report_template
    }
    status
    createdBy
    terms {
      id
      name
    }
    termNames
    subjects {
      id
      name
    }
    inviteCodes {
      id
      inviteCode
      role
      studentID
      campusID
    }
  }
}
`;

export const GET_SCHOOL_TERMS = gql`
query GetSchoolTerms($schoolID: Int) {
  getSchool(schoolID: $schoolID) {
    id
    activeTerm
    terms {
      id
      name
    }
  }
}
`;

export const GET_ALL_PARENT_INVITE_CODES = gql`
query GetAllParentInviteCodes($schoolID: Int) {
  getAllParentInviteCodes(schoolID: $schoolID) {
    id
    inviteCode
    role
    studentID
    campusID
  }
}
`;




export const CREATE_BULK_INVITE_CODES_FOR_ORPHAN_STUDENTS = gql`
mutation CreateBulkInviteCodesForOrphanStudents($schoolID: Int) {
  createBulkInviteCodesForOrphanStudents(schoolID: $schoolID) 
}
`;



export const GET_MESSAGE = gql`
query GetMessageByStudent($schoolID: Int, $studentID: Int, $offset: Int, $category: String) {
  getMessageByStudent(schoolID: $schoolID, studentID: $studentID, offset: $offset, category: $category) {
    id
    category
    studentID
    createdBy
    message
    file
    fileType
    isParent
    restricted
    created_at
  }
}
`;


export const ENROLL_PARENT = gql`
mutation EnrollParent($schoolId: Int, $studentIDs: [Int!], $email: String) {
  enrollParent(schoolID: $schoolId, studentIDs: $studentIDs, email: $email)
}
`;



export const GET_INVITE_CODES = gql`
query GetInviteCodes($input: InviteCodeInput) {
  getInviteCodes(input: $input) {
    id
    inviteCode
    role
    studentID
  }
}
`;


export const GET_BIRTHDAYS = gql`
query GetBirthdays($schoolID: Int) {
  getBirthdays(schoolID: $schoolID) {
    celebrant
    birthday
    contacts
    role
  }
}
`;
export const GET_CALENDAR = gql`
query GetCalendar($schoolID: Int) {
  getCalendar(schoolID: $schoolID) {
    date
    event
  }
}
`;

export const GET_RESOURCES = gql`
query GetResources($schoolID: Int) {
  getResources(schoolID: $schoolID) {
    id
    tag
    title
    category
    content
    createdBy
  }
}
`;


export const GET_LOGS = gql`
query GetLogs($schoolID: Int, $personID: Int) {
  getLogs(schoolID: $schoolID, personID: $personID) {
    id
    timestamp
    details
    createdBy
  }
}
`;

export const CREATE_MESSAGE = gql`
mutation CreateMessage($schoolID: Int, $input: MessageInput) {
  createMessage(schoolID: $schoolID, input: $input) 
}
`;

export const DELETE_MESSAGE = gql`
mutation DeleteMessage($schoolID: Int, $id: Int) {
  deleteMessage(schoolID: $schoolID, id: $id) 
}
`;



export const CHECK_IN_OUT = gql`
mutation CheckInOut($id: Int, $schoolID: Int, $category: PersonType!, $date: String!) {
  checkInOut(id: $id, schoolID: $schoolID, category: $category, date: $date)
}
`;

export const CHECK_IN = gql`
mutation CheckIn($id: Int, $schoolID: Int, $category: PersonType!, $date: String!) {
  checkIn(id: $id, schoolID: $schoolID, category: $category, date: $date)
}
`;



export const CHECK_OUT = gql`
mutation CheckOut($id: Int, $schoolID: Int, $category: PersonType!, $date: String!) {
  checkOut(id: $id, schoolID: $schoolID, category: $category, date: $date)
}
`;


export const CREATE_INVITE_CODES = gql`
mutation CreateInviteCodes($schoolID: Int, $quantity: Int, $role: StaffRoles, $studentID: Int) {
  createInviteCodes(schoolID: $schoolID, quantity: $quantity, role: $role, studentID: $studentID) 
}
`;


export const CREATE_CALENDAR = gql`
mutation CreateCalendar($schoolID: Int, $input: [InputCalendar!]) {
  createCalendar(schoolID: $schoolID, input: $input)
}
`;

export const CREATE_RESOURCE = gql`
mutation CreateResource($schoolID: Int, $input: ResourceInput!) {
  createResource(schoolID: $schoolID, input: $input) {
    id
    tag
    title
    category
    content
    createdBy
  }
}
`;

export const DELETE_INVITE_CODES = gql`
mutation DeleteInviteCode($id: Int, $schoolID: Int) {
  deleteInviteCode(id: $id, schoolID: $schoolID)
}
`;


export const SEND_BILL = gql`
mutation SendBill($schoolID: Int, $type: String!, $typeID: Int, $json: JSON, $session: String, $term: String) {
  sendBill(schoolID: $schoolID, type: $type, typeID: $typeID, json: $json, session: $session, term: $term)
}
`;



export const DELETE_BILL = gql`
mutation DeleteBill($schoolID: Int, $type: String!, $typeID: Int) {
  deleteBill(schoolID: $schoolID, type: $type, typeID: $typeID)
}
`;

export const UPDATE_FIREBASE_CODE = gql`
mutation UpdateFirebaseCode($code: String!) {
  updateFirebaseCode(code: $code)
}
`;


export const GENERAL_REPORTS = gql`
query Query($schoolID: Int, $type: String!, $startDate: Int, $endDate: Int) {
  getGeneralReports(schoolID: $schoolID, type: $type, startDate: $startDate, endDate: $endDate)
}
`;


export const UPDATE_ATTENDANCE = gql`
mutation UpdateAttendance($schoolID: Int, $personID: Int, $date: [String!], $checkin: String, $checkout: String, $category: String) {
  updateAttendance(schoolID: $schoolID, personID: $personID, date_: $date, checkin: $checkin, checkout: $checkout, category: $category)
}
`;



export const DELETE_ATTENDANCE = gql`
mutation deleteAttendance($schoolID: Int, $personID: Int, $date_: String, $category: String) {
  deleteAttendance(schoolID: $schoolID, personID: $personID, date_: $date_, category: $category)
}
`;

export const CREATE_CARD = gql`
mutation CreateCard($schoolID: Int, $personID: Int, $personName: String, $cardID: String, $personType: String) {
  createCard(schoolID: $schoolID, personID: $personID, personName: $personName, cardID: $cardID, personType: $personType)
}
`;



export const CLEAR_CARDS = gql`
mutation ClearCards($schoolID: Int, $maxDate: String, $personID: Int, $personType: String) {
  clearCards(schoolID: $schoolID, maxDate: $maxDate, personID: $personID, personType: $personType)
}
`;




export const GET_SMART_CARDS = gql`
query GetCards($schoolID: Int) {
  getCards(schoolID: $schoolID)
}`;



export const GET_SUBJECTS = gql`
query Query ($schoolID: Int){
  getSubjects(schoolID: $schoolID)
}
`;


export const SAVE_SUBJECTS = gql`
mutation SaveSubjects($schoolID: Int, $subjects: [String!]) {
  saveSubjects(schoolID: $schoolID, subjects: $subjects) {
    id
    name
  }
}
`;

export const SAVE_TERMS = gql`
mutation SaveTerms($schoolID: Int, $terms: [String!]) {
  saveTerms(schoolID: $schoolID, terms: $terms)
}
`;


export const GET_BILLS = gql`
query Query ($schoolID: Int){
  getBills(schoolID: $schoolID)
}
`;


export const GET_SUBSCRIPTIONS = gql`
query Query ($schoolID: Int){
  getSubscriptions(schoolID: $schoolID)
}
`;
export const GET_CONFIG = gql`
query Query {
  getConfig
}
`;

export const ANSWER_QUESTION = gql`
mutation AnswerQuestion($question: String) {
  answerQuestion(question: $question)
}
`;

export const GET_STAFF = gql`
query Query ($schoolID: Int) {
  getStaff(schoolID: $schoolID)
}
`;

export const GET_SMS = gql`
query Query ($schoolID: Int, $offset: Int) {
  getSMS(schoolID: $schoolID, offset: $offset)
}
`;

export const DELETE_SMS = gql`
mutation DeleteSMS($schoolID: Int, $id: Int) {
  deleteSMS(schoolID: $schoolID, id: $id)
}
`;

export const UPDATE_SMS = gql`
mutation UpdateSMS($schoolID: Int, $id: Int, $message: String) {
  updateSMS(schoolID: $schoolID, id: $id, message: $message)
}
`;

export const AUTOMATE_FACE_VECTOR = gql`
mutation AutoGenerateFacialData($schoolID: Int) {
  autoGenerateFacialData(schoolID: $schoolID)
}
`;

export const SAVE_FACE_VECTOR = gql`
mutation SaveFacialData($schoolID: Int, $personID: Int, $category: String, $vector: String) {
  saveFacialData(schoolID: $schoolID, personID: $personID, category: $category, vector: $vector)
}
`;

export const GET_FACE_VECTOR = gql`
query Query($schoolID: Int) {
  getFaceVectors(schoolID: $schoolID)
}
`;

export const FACE_CHECKIN = gql`
mutation FaceCheckIn($date: String!, $vector: String, $schoolID: Int) {
  faceCheckIn(date: $date, vector: $vector, schoolID: $schoolID)
}
`;

export const FACE_CHECKOUT = gql`
mutation FaceCheckOut($date: String!, $vector: String, $schoolID: Int) {
  faceCheckOut(date: $date, vector: $vector, schoolID: $schoolID)
}
`;

export const SAVE_CLASS_LIMIT = gql`
mutation SaveStaffClassLimit($schoolID: Int, $schoolUserID: Int, $limitToClass: [Int]) {
  saveStaffClassLimit(schoolID: $schoolID, schoolUserID: $schoolUserID, limitToClass: $limitToClass)
}
`;

export const GET_BOOK_TAGS = gql`
query GetBookTags($schoolID: Int) {
  getBookTags(schoolID: $schoolID)
}
`;
export const GET_BOOK_BY_TAG = gql`
query GetBooksByTag($schoolID: Int, $tag: String) {
  getBooksByTag(schoolID: $schoolID, tag: $tag)
}
`;

export const QUIT_SCHOOL = gql`
mutation QuitSchool($schoolID: Int, $type: String) {
  quitSchool(schoolID: $schoolID, type: $type)
}
`;